<div class="container">
  <form class="container" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="upper">
      <div class="auth-container">
        <div class="images">
          <img src="/assets/icons/Merck Logo.svg" alt="Image 1" />
          <img src="/assets/icons/My Co-creator Logo.svg" alt="Image 2" />
        </div>
        <button class="sso-button" type="submit">
          <img
            class="ms-logo"
            src="/assets/icons/Microsoft_logo.svg"
            alt="Image 1"
          />Sign In with Microsoft ID
        </button>
      </div>
    </div>

    <div class="footer">
      <div class="disclaimer-wrap">
        <div class="disclaimer">
          <div class="disclaimer-item">
            <span class="disclaimer-checkbox">
              <mat-checkbox formControlName="disclaimer"></mat-checkbox>
            </span>
            <div class="disclaimer-txt">
              
              I acknowledge that the app does not guarantee that the content  
              generated is complete, accurate, or free from errors. While it 
              is designed to assist me in my work, it should not be considered
               a substitute for my professional judgment or expertise. I will 
               always verify the information and use my discretion when relying 
               on the content output provided. I am responsible for the quality, 
               compliance, and accuracy of the content before finalizing the content 
               drafts for stakeholder review and approvals. By checking this box, 
               I confirm that I understand and accept these terms. Please read the 
               following terms and conditions and provide consent. For more information,
                please refer: <a
                href="https://evarooms.merckgroup.com/Topic/MerckData/mygpt/terms-conditions"
                target="_blank"
                >Merck Data and Analytics MyGPT Terms&Conditions</a
              >.
              <!-- ( <a routerLink="/login-ind"> Login </a>) -->
            </div>
          </div>

         

          @if (loginForm.controls['disclaimer'].invalid && loginForm.controls['disclaimer'].touched ) {
          <div class="error disclaimer-error">
            Please accept the terms and conditions to proceed.
          </div>
          }
        </div>
      </div>
    </div>
  </form>
</div>


